import { useEffect, useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, Modal, showToast } from "../../../../../../components";
import { useSelector } from "react-redux";
import { addAllLocalRestrictionApi, addLocationByBDMapi, addLocationRAapi, getLocationBDMapi, getLocationRAapi } from "../../../../../../redux/slices/setting/settingApi";
import { getCityLocations, getCountries, getLocations } from "../../../../../../redux/slices/internalDbES/internalDbESApi";

const GeneralSettingsBDMAddButtonModal = ({
    showAddButtonModal,
    setShowAddButtonModal,
    onSuccess
}) => {
    const [formData, setFormData, errors] = useState({
        stateName: "",
        stateCode: "",
        country: "",
        city: "",
        zipcode: ""
    });
    const [loading, setLoading] = useState(false);
    const [countryId, setCountryId] = useState("")
    const [stateCodeValue, setStateCodeValue] = useState()
    const [selectedCountry, setSelectedCountry] = useState({});
    const [locations, setLocations] = useState([]);
    const [locationTypingValue, setLocationTypingValue] = useState("");
    const [disablecheck, setDisableCheck] = useState(false)
     const [statesList, setStatesList] = useState([]);
     const [stateCodeMap, setStateCodeMap] = useState({});
     const [citiesList, setCitiesList] = useState([]);
const [cityZipMap, setCityZipMap] = useState({});
 const [stateId,setStateId] = useState("")

    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };
    const { user } = useSelector((state) => state.auth);
   
    const handleSave = async () => {
        if (!formData.stateName || !formData.stateCode || !formData.zipcode || !formData.city) {
            showToast("Please fill all fields", "error");
            return;
        }
        try {
            setLoading(true);
            const response = await addLocationByBDMapi({
                coll: "State",
                payload: {
                    stateName: formData.stateName,
                    country: countryId,
                    stateCode: formData.stateCode,
                    state:stateId,
                    cityName: formData?.city,
                    zipCode: formData?.zipcode,
                    addedBy: Number(user?.data?.uiid),
                    addedOn: new Date()
                },
            });

            if (response?.data) {
                showToast("Location added successfully!", "success");
                setFormData({
                    stateName: "",
                    stateCode: "",
                    country: "",
                    city: "",
                    zipcode: "",
                });
                setLocationTypingValue("");
                setStateCodeValue("")
                setShowAddButtonModal(false);
                if (onSuccess) onSuccess();
            } else {
                showToast(`${response?.field ?? "Failed to add location"}`, "error")
            }

        } catch (error) {
            console.error("Error adding location:", error);
            showToast("Failed to add Location. Please try again.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setFormData({
            stateName: "",
            stateCode: "",
            country: "",
            zipcode: "",
            city: "",
        });
        setShowAddButtonModal(false)
        setStateCodeValue("")
        setLocationTypingValue("")
    }

    useEffect(() => {
        if (!formData?.country) return;

        const delay = setTimeout(async () => {
            const response = await getCountries({
                name: formData?.country,
            });

            const countries = response.data.data;
            const desiredCountry = countries[0];
            setSelectedCountry(desiredCountry);
            setLocationTypingValue("");
        }, 0);

        return () => clearTimeout(delay);
    }, [formData?.country]);

    useEffect(() => {
        if (!locationTypingValue) return;
        const [city, state, zip] = locationTypingValue.split(",");
        if (city && state && zip) return;

        const delay = setTimeout(async () => {
            setLocations([]);
            const response = await getCityLocations({
            coll: "City",
            lim:1500,
            fil: JSON.stringify({ "country": { "type": "OBJECT_ID", "value":selectedCountry?._id }, "zipCode": { "type": "SEARCH", "value": locationTypingValue }, "stateName": { "type": "SEARCH", "value": formData.stateName }, "name": { "type": "SEARCH", "value": formData.city } })
                }
            );
            if (response?.success) {
                const uniqueStates = [
                    ...new Set(
                        (response?.data?.data || []).map((item) => item.stateName)
                    ),
                ];
                const locationData = response?.data?.data.flatMap((item) => {
                    const name = item.name ?? "";
                    const state = item.stateName ?? "";

                    // If zipCode is array, return one entry per zip
                    if (Array.isArray(item.zipCode)) {
                        return item.zipCode.map((zc) => `${name},${state},${zc}`);
                    }

                    // If zipCode is a single string
                    return [`${name},${state},${item.zipCode ?? ""}`];
                });
                // setLocations([...uniqueStates, ...locationData]);
                const search = locationTypingValue.toLowerCase();
                const statesStartsWith = uniqueStates.filter((item) =>
                    item.toLowerCase().startsWith(search)
                );
                const statesContains = uniqueStates.filter(
                    (item) =>
                        item.toLowerCase().includes(search) &&
                        !item.toLowerCase().startsWith(search)
                );
                const locationsStartsWith = locationData.filter((item) =>
                    item.toLowerCase().startsWith(search)
                );
                const locationsContains = locationData.filter(
                    (item) =>
                        item.toLowerCase().includes(search) &&
                        !item.toLowerCase().startsWith(search)
                );
                statesStartsWith.sort((a, b) => a.localeCompare(b));
                statesContains.sort((a, b) => a.localeCompare(b));
                locationsStartsWith.sort((a, b) => a.localeCompare(b));
                locationsContains.sort((a, b) => a.localeCompare(b));
                setLocations([
                    ...statesStartsWith,
                    ...locationsStartsWith,
                    ...statesContains,
                    ...locationsContains,
                ]);
            }
        }, 0);

        return () => clearTimeout(delay);
    }, [locationTypingValue, formData?.country]);

 
  
useEffect(() => {
    if (!countryId) return;
  if (statesList.includes(formData?.stateName)) { setStatesList([]); return}
    const fetchStates = async () => {
        const response = await getLocationRAapi({
            coll: "State",
            fil: JSON.stringify({
                name: {
                    type: "SEARCH",
                    value: formData?.stateName || ""
                },
                country: {
                    type: "NONE",
                    value: countryId
                }
            }),
            ret: "name stateCode _id",
            lim: 1500
        });

      if (response?.success) {
    const search = (formData?.stateName || "").toLowerCase();

    const rawStates = response?.data?.data || [];
        const selectedState = rawStates.find(item => item.name === formData.stateName);
if (selectedState?._id) setStateId(selectedState._id);

    const allStates = rawStates
        .map((item) => item.name)
        .filter(Boolean);

    // Build lookup map
    const codeMap = {};
    rawStates.forEach((item) => {
        if (item.name && item.stateCode) {
            codeMap[item.name] = item.stateCode;
        }
    });

    setStateCodeMap(codeMap);

    const startsWith = allStates
        .filter((name) => name.toLowerCase().startsWith(search))
        .sort((a, b) => a.localeCompare(b));

    const contains = allStates
        .filter(
            (name) =>
                !name.toLowerCase().startsWith(search) &&
                name.toLowerCase().includes(search)
        )
        .sort((a, b) => a.localeCompare(b));

    if (!search) {
        setStatesList(allStates.sort((a, b) => a.localeCompare(b)));
    } else {
        setStatesList([...startsWith, ...contains]);
    }
}

    };

    fetchStates();
}, [formData?.stateName, countryId]);



useEffect(() => {
    if (!countryId || !formData?.stateName) return;
      const isExactMatch =
    citiesList.length &&
    citiesList.some(
      (c) => c.toLowerCase() === (formData.city || "").toLowerCase()
    );

  if (isExactMatch) {
    setCitiesList([]); // close dropdown after selection
    return;
  }

    const fetchCities = async () => {
        const response = await getLocationBDMapi({
            coll: "City",
            fil: JSON.stringify({
                name: {
                    type: "SEARCH",
                    value: formData?.city || ""
                },
                stateName: {
                    type: "NONE",
                    value: formData.stateName
                },
                country: {
                    type: "NONE",
                    value: countryId
                }
            }),
            ret: "name zipCode",
            lim: 1500
        });

        if (response?.success) {
            const search = (formData?.city || "").toLowerCase();
            const rawCities = response?.data?.data || [];

            const allCities = rawCities
                .map((item) => item.name)
                .filter(Boolean);
            const zipMap = {};
            rawCities.forEach((item) => {
                if (item.name && Array.isArray(item.zipCode)) {
                    zipMap[item.name] = item.zipCode;
                }
            });
            setCityZipMap(zipMap);

            const startsWith = allCities
                .filter((name) =>
                    name.toLowerCase().startsWith(search)
                )
                .sort((a, b) => a.localeCompare(b));
            const contains = allCities
                .filter(
                    (name) =>
                        !name.toLowerCase().startsWith(search) &&
                        name.toLowerCase().includes(search)
                )
                .sort((a, b) => a.localeCompare(b));
            if (!search) {
                setCitiesList(
                    allCities.sort((a, b) => a.localeCompare(b))
                );
            } else {
                setCitiesList([...startsWith, ...contains]);
            }
        }else{
     setCitiesList([]);
            setCityZipMap({});
}
    };

    fetchCities();
}, [formData?.city]);

    return (

        <Modal
            isOpen={showAddButtonModal}
            onClose={handleClose}
            title="Details"
            titleColor={"primary"}
            width="max-w-xl"
        >
            <div className="grid grid-cols-2 gap-3 my-3">
                <FormFieldSet
                    type="countriesUsAndCanada"
                    title="Country"
                    placeholder="Enter Country Full Name"
                    value={formData.country}
                    onChange={(value) => {
                        handleChange("country", value.value)
                        handleChange("stateName", "")
                        handleChange("stateCode", "")
                        handleChange("city", "")
                        handleChange("zipcode", "")
                        setStateCodeValue("")
                        setLocationTypingValue("")
                        setCountryId(value?.id)
                    }}
                />
                <FormFieldSet
                    parentValue={{
                        country: formData?.country,
                    }}
                    title="states"
                    placeholder="Enter State Full Name"
                    value={formData.stateName}
                   onChange={(value) => {
        handleChange("stateName", value);

        const code = stateCodeMap[value];
        if (code) {
            handleChange("stateCode", code);
            setStateCodeValue(code);
        }else {
             handleChange("stateCode", "");
                  setStateCodeValue("");
        }

        handleChange("city", "");
        handleChange("zipcode", "");
        setStateId("");

    }}
                    disabled={!formData?.country}
                    required
                      suggestionsList={statesList}
                />
                <FormFieldSet
                    title="State Code"
                    placeholder="Enter State Code"
                    parentValue={{
                        stateName: formData?.stateName,
                    }}
                    value={stateCodeValue || formData.stateCode}
                     onChange={(value) => {
                        const trimmedValue = value.slice(0, 6);

                        setStateCodeValue(trimmedValue);          
                        handleChange("stateCode", trimmedValue); 
                        handleChange("zipcode", "");
                    }}
                    required
                    disabled={!formData.stateName}
                />
               <FormFieldSet
    title="City"
    placeholder="Select City"
    value={formData.city}
    onChange={(value) => {
        handleChange("city", value);

        const zips = cityZipMap[value];
        if (zips?.length > 0) {
            if (zips.length > 0) {
                handleChange("zipcode", zips[0]);
                setLocationTypingValue(zips[0]);
            } else {
                handleChange("zipcode", "");
                setLocationTypingValue("");
            }
        }
        else {
                handleChange("zipcode", "");
                setLocationTypingValue("");
            }

        setLocations(zips || []);
    }}
    suggestionsList={citiesList}
    required
    disabled={!formData.stateName}
/>

                <FormFieldSet
                    title="Zip Code"
                    placeholder="Enter Zip Code"
                    parentValue={{
                        stateName: formData?.city,
                    }}
                    value={(locationTypingValue || "").slice(0, 6)}
                    onChange={(value) => {
                        const sanitizedValue =
                            formData.country === "Canada"
                                ? value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 6)
                                : value.replace(/\D/g, "").slice(0, 6);
                                
                        const existsInSuggestions = locations?.some(
                            (item) => sanitizedValue.length >= 5 && item.includes(sanitizedValue)
                        );
                        if (existsInSuggestions) {
                        }

                        setLocationTypingValue(sanitizedValue);
                        handleChange("zipcode", sanitizedValue || "");
                    }}
                    suggestionsList={locations}
                    required
                    disabled={disablecheck || (!formData.city)}
                />
            </div>
            <div className="flex items-center justify-end gap-2 mt-20">
                <Button
                    variant="outlined"
                    title="Cancel"
                    size="sm"
                    onClick={handleClose}
                    disabled={loading}
                />
                <Button title="Save" size="sm" onClick={handleSave} />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </Modal>
    );
};

export default GeneralSettingsBDMAddButtonModal;
